export class Cita {
    fecha: string;
    hora: string;
    descripcion: string;
    agenda: string;
    centro: string;
    id: string;
    demandante: string;
    duracion: string;
    borrable: boolean;
}



// WEBPACK FOOTER //
// ./src/models/cita.ts